<template>
  <v-row no-gutters>
    <v-col sm="12" v-if="selectedArchiveId === null">
      <v-row no-gutters class="mt-4">
        <x-table
          :showSelectAll="projectStatus !== $enums.projectStatus.ARCHIVED"
          :changeCheckState="checkState"
          :selectAllItems="
            status =>
              (this.selectedItems = selectAll({
                status,
                key: 'archiveId',
                data: archiveList
              }))
          "
          :columns="columns"
          :sortBy="sortUsers"
          :loading="loading"
          :updateTableSize="updateTableRowCount"
          :tableRows="archiveList"
          :paginationData="{
            pageSize,
            pageNumber,
            totalRecords,
            setPage: changePage
          }"
          :data-test-id="`${dataTestId}__table`"
        >
          <template slot="table-top-right">
            <x-button
              v-show="selectedItems.length"
              class="v-btn w-auto"
              buttonText="Remove from Saved Items"
              @click="removeFromSaved"
              color="#58e2c2"
              :data-test-id="`${dataTestId}__remove-save-item-btn`"
            />
          </template>
          <template slot="table_item" slot-scope="props">
            <tr v-for="(item, index) in props.tableRows" :key="item.id">
              <td v-if="projectStatus !== $enums.projectStatus.ARCHIVED">
                <Checkbox
                  :id="'prail-checkbox' + index"
                  theme="light"
                  :value="item.archiveId"
                  v-model="selectedItems"
                ></Checkbox>
              </td>
              <td class="text-left pointerCursor" @click="gotoArchive(item)">
                <v-icon class="icon-top4" v-if="item.hasAttachment"
                  >attachment</v-icon
                >
                <span class="clickable">{{ item.subject }}</span>
              </td>
              <td class="text-left">
                <span>{{ item.from }}</span>
              </td>
              <td class="text-left">
                <span>{{ item.recipient }}</span>
              </td>
              <td class="text-left">
                <span>{{ item.date }}</span>
              </td>
              <td class="text-left">
                <span :inner-html.prop="item.tags | sanitize"></span>
              </td>
            </tr>
          </template>
        </x-table>
      </v-row>
    </v-col>
    <loader v-if="overlay" />
  </v-row>
</template>

<script>
import EventBus from '@/EventBus';
import ProjectService from '@/services/ProjectService';
import Checkbox from '@/components/Common/Checkbox';
import httpCodes from '../../../constants/httpCodes';
import { mapState } from 'vuex';
import { getTableColumns, selectAll } from '@/helpers/TableHelpers';
export default {
  name: 'SavedArchiveListing',
  data() {
    return {
      currentPageArchiveIndex: {},
      componentKey: 1,
      overlay: false,
      // only owner can select items
      canSelectItems: false,
      loading: false,
      selectedArchiveId: null,
      selectedItems: [],
      pageNumber: 1,
      pageSize: 20,
      archiveList: [],
      totalRecords: 0,
      currentSort: {
        sortBy: 'date',
        sortOrder: 'DESC'
      },
      selectAll,
      columns: [...getTableColumns('projectArchivedEmail')],
      checkState: null,
      dataTestId:'discovery-project__saved-emails'
    };
  },
  computed: {
    ...mapState(['projectDetails']),
    projectStatus() {
      return this.projectDetails?.projectStatus || '';
    },
    projectOwner() {
      return this.projectDetails?.projectOwner || '';
    }
  },
  components: {
    Checkbox
  },
  methods: {
    gotoArchive(params) {
      this.$router.push({
        path:
          '/discovery/projects/' +
          this.$route.params.projectId +
          '/archive/' +
          encodeURIComponent(params.archiveId)
      });
    },
    updateTableRowCount(data) {
      this.pageSize = data;
      this.changePage(1);
    },
    async removeFromSaved() {
      this.checkState = true;
      if (!this.selectedItems.length) {
        this.snackbar('error', this.$message.SELECT_ITEMS);
        return false;
      }
      this.overlay = true;
      try {
        await ProjectService.removeArchives(this.$route.params.projectId, {
          archives: this.selectedItems,
          archiveType: this.$enums.archiveType.EMAIL
        });

        this.snackbar('success', this.$message.ITEMS_REMOVED);
        this.selectedItems = [];

        this.changePage(1);
        EventBus.$emit('REFRESH_COLLABORATORS', true);

        this.overlay = false;
      } catch (err) {
        let errData = err.response.data;
        if (errData.errors) {
          this.snackbar('error', errData.errors[0].message);
        } else {
          this.snackbar('error', err);
        }
        this.overlay = false;
      }
      this.checkState = false;
    },
    displayTags(tags) {
      if (!tags.length) {
        return '-';
      }
      let str = '';
      tags.forEach(tag => {
        str += tag.tag + '(' + tag.count + ')';
        str += '<br>';
      });
      return str;
    },
    changePage(page) {
      if (page !== Number(this.pageNumber)) {
        this.pageNumber = page;
        this.$router.push('p' + this.pageNumber);
      }
      this.getArchivesForProject();
    },

    async getArchivesForProject() {
      this.archiveList = [];
      this.loading = true;
      try {
        let params = {
          pageNumber: this.pageNumber,
          pageSize: this.pageSize
        };
        if (this.$route.params.tagname) {
          params['tags'] = this.$route.params.tagname;
        }

        let archiveResponse = await ProjectService.getArchiveList(
          this.$route.params.projectId,
          params
        );
        this.componentKey++;
        this.overlay = false;
        if (!archiveResponse.data.success) {
          this.loading = false;
          return false;
        }
        let archiveIds = archiveResponse.data.body[0].archives;
        this.totalRecords = archiveResponse.data.body[0].total;
        EventBus.$emit('CURRENT_TAB_COUNT', {
          total: this.totalRecords,
          type: 'EMAIL'
        });
        if (!archiveIds.length) {
          this.loading = false;
          this.snackbar('info', this.$message.NO_ARCHIVES + ' of email type');
          return false;
        }
        params['sortBy'] = this.currentSort.sortBy;
        params['sortOrder'] = this.currentSort.sortOrder;

        let archiveDetails = await ProjectService.getArchiveDetails(params, {
          archiveIds: archiveIds
        });
        if (!archiveDetails.data.success) {
          this.loading = false;
          return false;
        }
        let archiveList = archiveDetails.data.body[0].results;
        if (!archiveList.length) {
          this.loading = false;

          this.snackbar('info', this.$message.NO_RESULTS + ' of email type');
          return;
        }

        let topTags = await ProjectService.getTopTags(
          this.$route.params.projectId,
          archiveIds
        );
        if (topTags.data.success) {
          topTags = topTags.data.body;
          archiveList.map(item => (item['tags'] = topTags[item.id]));
        }
        let all = [];
        archiveList.forEach(archive => {
          all.push({
            archiveId: archive.id,
            subject: archive.subject,
            from: archive.from,
            recipient: this.getEmailList(archive.recipients),
            date: this.getFormatedDateAsPerTimeZone(archive.date),
            tags: this.displayTags(archive.tags),
            hasAttachment:
              (archive.attachments && archive.attachments.length) || 0
          });
        });
        this.archiveList = all;
        this.currentPageArchiveIndex = this.getPageRecordFromToIndex(
          this.pageNumber,
          this.pageSize,
          this.archiveList.length
        );
        this.loading = false;
      } catch (err) {
        if (err.response && err.response.status === httpCodes.FORBIDDEN) {
          this.snackbar(
            'error',
            'You do not have permission to perform this action. Please contact your administrator.'
          );
        } else {
          this.snackbar('error', this.$message.NO_RESULTS);
        }
        this.overlay = false;
        this.loading = false;
      }
    },
    sortUsers(tableSortData) {
      this.currentSort.sortBy = tableSortData.sortBy;
      this.currentSort.sortOrder = tableSortData.sortOrder;
      this.getArchivesForProject();
    }
  },
  mounted() {
    this.pageNumber =
      (this.$route.params && parseInt(this.$route.params.pageNumber, 10)) || 1;

    this.loading = true;
    if (
      this.projectStatus !== this.$enums.projectStatus.ARCHIVED &&
      this.projectOwner === this.userInformation?.userId
    ) {
      this.canSelectItems = true;
    }
    this.getArchivesForProject();
  }
};
</script>
